import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import SideDrawer from "../components/miscellaneous/SideDrawer";
import MyChats from "../components/MyChats";
import { ChatState } from "../Context/ChatProvider";
import Chatbox from "../components/ChatBox";

const Chatpage = () => {
  const [fetchAgain, setFetchAgain] = useState(false);
  const { user } = ChatState();

  return (
    <div style={{ width: "100%" }}>
      {user && <SideDrawer />}
      <Box
        display="flex"
        justifyContent="space-between"
        w="100%"
        h="91.5vh"
        p="10px"
      >
        {user && <MyChats fetchAgain={fetchAgain} />}
        {user && (
          <Chatbox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
        )}
      </Box>
    </div>
  );
};

export default Chatpage;
// import React, { useState } from "react";
// import { Box } from "@chakra-ui/react";
// import SideDrawer from "../components/miscellaneous/SideDrawer";
// import MyChats from "../components/MyChats";
// import { ChatState } from "../Context/ChatProvider";
// import Chatbox from "../components/ChatBox";

// const Chatpage = () => {
//   const [fetchAgain, setFetchAgain] = useState(false);
//   const { user } = ChatState();

//   if (!user) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div style={{ width: "100%" }}>
//       <SideDrawer />
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         w="100%"
//         h="91.5vh"
//         p="10px"
//       >
//         <MyChats fetchAgain={fetchAgain} />
//         <Chatbox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
//       </Box>
//     </div>
//   );
// };

// export default Chatpage;
